exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dropDownNotification{position:fixed;left:50%;width:550px;margin-left:-250px;padding:10px;color:#fff;border-radius:4px;z-index:1150000;cursor:pointer;-webkit-transition:top .4s;-webkit-transition-timing-function:cubic-bezier(.5,-.5,.5,1.5);transition:top .4s;transition-timing-function:cubic-bezier(.5,-.5,.5,1.5);top:50px}.dropDownNotification.drop-down-enter.drop-down-enter-active{top:50px}.dropDownNotification.drop-down-enter,.dropDownNotification.drop-down-exit{top:-100px}.dropDownNotification.success{background-color:#2b9401}.dropDownNotification.error{background-color:#c54e14}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/notifications/drop_down_notifications.scss
// module id = 1316
// module chunks = 0